import { ExclamationCircleOutlined } from "@ant-design/icons";
import { AlertBox } from "@life-line-lab/components-react";
import { Row, Col, Checkbox, TimePicker } from "antd";
import { useTranslation } from "react-i18next";
import { Day } from "Types/common.types";
import React, { FC } from "react";
import { CheckboxChangeEvent } from "antd/lib/checkbox";
import { Moment } from "moment";
import { OperationHoursTimeEnums } from "Data/order";

interface OperationalHoursComponent {
  indeterminate: boolean;
  isAllSelected: boolean;
  input: any;
  error: any;
  handleWorkingHourChange: (e: CheckboxChangeEvent, day: Day) => void;
  handleTimeChange: (
    time: Moment | null,
    day: Day,
    type: OperationHoursTimeEnums,
  ) => void;
}

const OperationalHoursComponent: FC<OperationalHoursComponent> = (props) => {
  const {
    indeterminate,
    isAllSelected,
    input,
    error,
    handleWorkingHourChange,
    handleTimeChange,
  } = props || {};
  const { t } = useTranslation();

  return (
    <div className="oh-container">
      <div>
        <label className="inp-label inp-label--required">
          {t("label.operationalHours")}
        </label>
      </div>
      <div className="oh-container-inner">
        <Row gutter={[0, 16]}>
          <Col span={24}>
            <div className="oh-select-all">
              <Checkbox
                indeterminate={indeterminate}
                checked={isAllSelected}
                onChange={(e) => handleWorkingHourChange(e, "everyday" as Day)}
              >
                {t(`label.selectAll`)}
              </Checkbox>
              {isAllSelected && (
                <div className="cm-info cm-help">
                  <ExclamationCircleOutlined style={{ fontSize: "16px" }} />
                  <div>{t("txt.setOperationalHoursEveryDay")}</div>
                </div>
              )}
            </div>
          </Col>
          <div className="oh-divider"></div>
          <Col span={24}>
            <Row gutter={[32, 0]}>
              <AlertBox text={error.workingHours} />
              <Col span={12}>
                <Row gutter={[16, 16]} align="middle">
                  {input?.workingHours?.map((current, index) => {
                    if (index < 4)
                      return (
                        <>
                          <Col span={8}>
                            <Checkbox
                              checked={current?.isChecked}
                              onChange={(e) =>
                                handleWorkingHourChange(e, current?.day as Day)
                              }
                            >
                              {t(`label.${current?.day?.toUpperCase()}`)}
                            </Checkbox>
                          </Col>
                          <Col span={8}>
                            <TimePicker
                              format={"hh:mm a"}
                              placeholder={t("txt.openingHours")}
                              value={current?.openingTime}
                              onChange={(time) => {
                                handleTimeChange(
                                  time,
                                  current?.day as Day,
                                  OperationHoursTimeEnums.OPENING_TIME,
                                );
                              }}
                            />
                          </Col>
                          <Col span={8}>
                            <TimePicker
                              format={"hh:mm a"}
                              placeholder={t("txt.closingHours")}
                              value={current?.closingTime}
                              onChange={(time) => {
                                handleTimeChange(
                                  time,
                                  current?.day as Day,
                                  OperationHoursTimeEnums.CLOSING_TIME,
                                );
                              }}
                            />
                          </Col>
                        </>
                      );
                  })}
                </Row>
              </Col>
              <Col span={12}>
                <Row gutter={[16, 16]} align="middle">
                  {input?.workingHours?.map((current, index) => {
                    if (index >= 4)
                      return (
                        <>
                          <Col span={8}>
                            <Checkbox
                              checked={current?.isChecked}
                              onChange={(e) =>
                                handleWorkingHourChange(e, current?.day as Day)
                              }
                            >
                              {t(`label.${current?.day?.toUpperCase()}`)}
                            </Checkbox>
                          </Col>
                          <Col span={8}>
                            <TimePicker
                              format={"hh:mm a"}
                              placeholder={t("txt.openingHours")}
                              value={current?.openingTime}
                              onChange={(time) => {
                                handleTimeChange(
                                  time,
                                  current?.day as Day,
                                  "openingTime",
                                );
                              }}
                            />
                          </Col>
                          <Col span={8}>
                            <TimePicker
                              format={"hh:mm a"}
                              placeholder={t("txt.closingHours")}
                              value={current?.closingTime}
                              onChange={(time) => {
                                handleTimeChange(
                                  time,
                                  current?.day as Day,
                                  "closingTime",
                                );
                              }}
                            />
                          </Col>
                        </>
                      );
                  })}
                </Row>
              </Col>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default OperationalHoursComponent;
